import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateRequest } from "../api/queries";
import { RequestForm } from "../ui/RequestForm";

export function RequestCreatePage() {
  const nav = useNavigate({ from: "/app/performance/requests/create" });
  const createRequest = useCreateRequest();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຄິວ", to: "/app/performance/requests" },
            { label: "ສ້າງໃໝ່" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ສ້າງຄຳຂໍໃໝ່</h2>
          <p className="text-muted-foreground">
            ເພີ່ມຄຳຂໍຂອງລູກຄ້າເຂົ້າສູ່ pipeline ງານສະແດງ.
          </p>
        </div>

        <div className="rounded-xl border bg-card px-6 pt-6">
          <RequestForm
            onSubmit={async (vals) => {
              try {
                const created = await createRequest.mutateAsync(vals);
                nav({
                  to: "/app/performance/requests/$id",
                  params: { id: created.id },
                });
              } catch {}
            }}
            onCancel={() => nav({ to: "/app/performance/requests" })}
            submitting={createRequest.isPending}
          />
        </div>
      </Main>
    </>
  );
}
